import React, { Fragment } from "react";
import { DateDropDown } from "../Date/index.js";
import { Divider } from "@bookingcom/bui-react";
import { OriginDestinationVerticalInline } from "../OriginDestination/index.js";
import { ShellWrapper } from "../Shell/index.js";
import RemoveSegment from "./RemoveSegment.js";
import useSegment from "./useSegment.js";
import styles from "./SegmentVerticalInline.module.css";
const SegmentVerticalInline = () => {
    const { isMultiStop, segments } = useSegment();
    return (React.createElement(React.Fragment, null, segments.map((_, idx) => (React.createElement(Fragment, { key: idx }, isMultiStop ? (React.createElement("fieldset", null,
        React.createElement(ShellWrapper, { fill: true, "data-ui-name": `segment_${idx}` },
            React.createElement("div", { className: styles.wrapper },
                React.createElement(OriginDestinationVerticalInline, { segmentIndex: idx }),
                React.createElement(Divider, null),
                React.createElement(DateDropDown, { errorVariant: "inline", position: "end", segmentIndex: idx }),
                React.createElement("div", { className: styles.removeWrapper },
                    React.createElement(RemoveSegment, { className: styles.remove, disabled: segments.length === 1, segmentIndex: idx })))))) : (React.createElement(React.Fragment, null,
        React.createElement(ShellWrapper, { fill: true, "data-ui-name": `segment_${idx}` },
            React.createElement(OriginDestinationVerticalInline, { segmentIndex: idx })),
        React.createElement(DateDropDown, { errorVariant: "inline", position: "end", segmentIndex: idx }))))))));
};
export default SegmentVerticalInline;
